import script from "./Main.vue?vue&type=script&lang=ts&setup=true"
export * from "./Main.vue?vue&type=script&lang=ts&setup=true"

import "./Main.vue?vue&type=style&index=0&id=0473fe21&lang=less"

const __exports__ = script;

export default __exports__